import * as React from 'react';
import { Sun, Moon } from 'lucide-react';
import { cn } from './lib/utils';

/**
 * Light / Dark toggle.
 * Props: theme ('light' | 'dark'), onChange (fn)
 */
function ThemeToggle({ theme, onChange, className }) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded bg-surface p-0.5 gap-0.5',
        className
      )}
      role="group"
      aria-label="Theme"
    >
      <button
        type="button"
        onClick={() => onChange('light')}
        aria-pressed={theme === 'light'}
        className={cn(
          'inline-flex items-center gap-1.5 rounded px-2.5 py-1 text-body-sm font-medium transition-colors',
          theme === 'light'
            ? 'bg-nn-white text-aqua shadow-sm ring-1 ring-nn-border'
            : 'text-text-dark-secondary hover:text-text-dark'
        )}
      >
        <Sun className="h-3.5 w-3.5" />
        Light
      </button>
      <button
        type="button"
        onClick={() => onChange('dark')}
        aria-pressed={theme === 'dark'}
        className={cn(
          'inline-flex items-center gap-1.5 rounded px-2.5 py-1 text-body-sm font-medium transition-colors',
          theme === 'dark'
            ? 'bg-nn-white text-aqua shadow-sm ring-1 ring-nn-border'
            : 'text-text-dark-secondary hover:text-text-dark'
        )}
      >
        <Moon className="h-3.5 w-3.5" />
        Dark
      </button>
    </div>
  );
}

export { ThemeToggle };
